module.exports = __webpack_public_path__ + "static/media/Onest-Medium.02926d5f.woff2";